// ConnectionCard.js

import React, { useContext, useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Button,
  Card,
  Grid,
  IconButton,
  Typography,
  Drawer,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Tooltip,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VerifiedIcon from "@mui/icons-material/Verified";

import { useDrawer } from "./DrawerContext";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import axios from "axios";
import { BlockOutlined } from "@mui/icons-material";
import { styled } from "@mui/material/styles"
import WarningAmberIcon from "@mui/icons-material/WarningAmber"
import CloseIcon from "@mui/icons-material/Close"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 12,
    boxShadow: theme.shadows[10],
    padding: theme.spacing(1),
  },
}))

const DialogHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(1),
}))

const WarningIcon = styled(WarningAmberIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 28,
}))

const ConnectionCard = ({ friend, handleViewProfile, getConnectionList }) => {
  const theme = useTheme();
  const { drawerOpen, setDrawerOpen, openDrawerForUserId } = useDrawer();
  const [messageBody, setMessageBody] = useState("");
  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();
  const [open, setOpen] = useState(false);
  const [openBlock, setOpenBlock] = useState(false)

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const handleConfirmUnfriend = () => {
    handleUnfriend(friend?.connectionRequestId);
    setOpen(false);
  };

  const handleConfirmBlock = () => {
    handleBlock(friend?.id);
    setOpen(false);
  };


  const handleOpenBlock = () => {
    setOpenBlock(true);
  };
  const handleCloseBlock = () => setOpenBlock(false);


  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleSendMessage = () => {
    setDrawerOpen(false);
  };

  const handleUnfriend = async (connectionRequestId) => {
    const response = await axios.put(
      `/v1/connection/revoke/${connectionRequestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      }
    );
    getConnectionList()
      .then((value) => {
        dispatch(
          openSnackbar({
            open: true,
            message: `You have unfriended ${friend?.friendAlumni?.name} successfully.`,
            variant: "alert",
            alert: {
              color: "success",
            },
            close: false,
          })
        );
        generateTimeStamp();
      })
      .catch((error) => {
        if (error.response.status === 404) {
          generateTimeStamp();
          dispatch(
            openSnackbar({
              open: true,
              message: response?.data?.data.Msg,
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        } else {
          dispatch(
            openSnackbar({
              open: true,
              message: "Something went wrong",
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        }
      });
  };

  const handleBlock = async (connectionRequestId) => {
    const response = await axios.get(
      `/v1/connection/block-connection?friendId=${connectionRequestId}`,
      {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      }
    );
    getConnectionList()
      .then((value) => {
        dispatch(
          openSnackbar({
            open: true,
            message: `You have blocked ${friend?.friendAlumni?.name} successfully.`,
            variant: "alert",
            alert: {
              color: "success",
            },
            close: false,
          })
        );
        generateTimeStamp();
      })
      .catch((error) => {
        if (error.response.status === 404) {
          generateTimeStamp();
          dispatch(
            openSnackbar({
              open: true,
              message: response?.data?.data.Msg,
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        } else {
          dispatch(
            openSnackbar({
              open: true,
              message: "Something went wrong",
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        }
      });
  };

  return (
    <>
      <Card
        sx={{
          p: 2,
          background:
            theme.palette.mode === "dark"
              ? theme.palette.dark.main
              : theme.palette.grey[50],
          border: "1px solid",
          borderColor:
            theme.palette.mode === "dark"
              ? theme.palette.dark.main
              : theme.palette.grey[100],
          "&:hover": {
            border: `1px solid ${theme.palette.primary.main}`,
          },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item>
                <Avatar
                  alt="User 1"
                  src={`data:image/*;base64, ${friend?.friendAlumni?.avatar?.data}`}
                  sx={{
                    border: !friend?.friendAlumni?.starAlumni
                      ? null
                      : "3px solid #D89E46",
                  }}
                />
              </Grid>
              <Grid item xs zeroMinWidth>
                <Typography
                  onClick={() => handleViewProfile(friend?.friendAlumni?.userId)}
                  variant="h5"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    margin: 0,
                    cursor: "pointer",
                  }}
                >
                  {friend?.friendAlumni?.name}
                  {friend?.friendAlumni?.starAlumni && (
                    <VerifiedIcon
                      sx={{
                        color: "#D89E46",
                        fontSize: "18px",
                        marginLeft: "4px",
                      }}
                    />
                  )}
                  <Tooltip title="View Profile" arrow>
                    <VisibilityIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        handleViewProfile(friend?.friendAlumni?.userId);
                      }}
                      sx={{
                        color: "#1976d2",
                        fontSize: "20px",
                        marginLeft: "6px",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>

                </Typography>

                <Typography>
                  {
                    friend?.friendAlumni?.careerStatus === "Higher_Education"
                      ? "Higher Education"
                      : friend?.friendAlumni?.careerStatus === "Self_Employment"
                        ? "Self Employed"
                        : friend?.friendAlumni?.careerStatus === "Working"
                          ? "Employed"
                          : friend?.friendAlumni?.careerStatus || ""
                  }

                </Typography>
                <Typography>{friend?.friendAlumni?.batchTag}</Typography>
              </Grid>
              {/* <Grid item>
                <Tooltip title="Compose Message">
                  <IconButton onClick={toggleDrawer(true)}>
                    <MessageOutlined />
                  </IconButton>
                </Tooltip>
              </Grid> */}
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} mt={1}>
                <Button
                  onClick={handleOpen}
                  variant="outlined"
                  color="error"
                  fullWidth
                  startIcon={<PersonRemoveIcon />}
                >
                  Unfriend
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} mt={1}>
                <IconButton
                  onClick={handleOpenBlock}
                  variant="outlined"
                  color="error"
                >
                  <BlockOutlined />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>

      <Drawer
        anchor="bottom"
        open={
          drawerOpen && openDrawerForUserId === friend?.friendAlumni?.userId
        }
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            height: "auto",
            minHeight: "200px",
            maxHeight: "400px",
            width: "600px",
            margin: "16px",
            boxShadow: 3,
            borderRadius: 2,
            position: "fixed",
            bottom: 0,
            right: 0,
            transform: "translateX(-16px)", // Adjusting for the margin
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" component="div" gutterBottom>
            Message to {friend?.friendAlumni?.name}
          </Typography>

          <TextField
            id="message-body"
            label="Message"
            multiline
            rows={4}
            fullWidth
            value={messageBody}
            onChange={(e) => setMessageBody(e.target.value)}
            margin="normal"
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendMessage}
            sx={{ mt: 2, alignSelf: "flex-end" }}
          >
            Send
          </Button>
        </Box>
      </Drawer>
      <StyledDialog
        open={open}
        onClose={handleClose}
        aria-labelledby="unfriend-dialog-title"
        aria-describedby="unfriend-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ position: "relative", p: 1 }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle id="unfriend-dialog-title" sx={{ p: 2, pb: 0 }}>
            <DialogHeader>
              <WarningIcon />
              <Typography variant="h4">
                Are you sure?
              </Typography>
            </DialogHeader>
          </DialogTitle>

          <DialogContent sx={{ p: 2, pt: 1 }}>
            <DialogContentText id="unfriend-dialog-description" sx={{ mb: 1 }}>
              Are you sure you want to block this person <strong>{friend?.friendAlumni?.name}</strong>? This action cannot be undone.
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ p: 2, pt: 0, justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={handleClose} variant="outlined" sx={{ borderRadius: 2 }}>
              Cancel
            </Button>
            <Button onClick={handleConfirmUnfriend} color="error" variant="contained" sx={{ borderRadius: 2 }}>
              Unfriend
            </Button>
          </DialogActions>
        </Box>
      </StyledDialog>

      {/* Block Dialog */}
      <StyledDialog
        open={openBlock}
        onClose={handleCloseBlock}
        aria-labelledby="block-dialog-title"
        aria-describedby="block-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ position: "relative", p: 1 }}>
          <IconButton
            aria-label="close"
            onClick={handleCloseBlock}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <DialogTitle id="block-dialog-title" sx={{ p: 2, pb: 0 }}>
            <DialogHeader>
              <WarningIcon />
              <Typography variant="h4">
                Are you sure?
              </Typography>
            </DialogHeader>
          </DialogTitle>

          <DialogContent sx={{ p: 2, pt: 1 }}>
            <DialogContentText id="block-dialog-description" sx={{ mb: 1 }}>
              Are you sure you want to block this person <strong>{friend?.friendAlumni?.name}</strong>?
            </DialogContentText>
          </DialogContent>

          <DialogActions sx={{ p: 2, pt: 0, justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={handleCloseBlock} variant="outlined" sx={{ borderRadius: 2 }}>
              Cancel
            </Button>
            <Button onClick={handleConfirmBlock} color="error" variant="contained" sx={{ borderRadius: 2 }}>
              Block
            </Button>
          </DialogActions>
        </Box>
      </StyledDialog>
    </>
  );
};

export default ConnectionCard;
